import childupp from './app.module';
export default childupp;

// find ./ -type f -name "*.js"
import './app.component';
import './common/app-providers-config';
import './common/components/dim-overlay/dim-overlay.component';
import './common/components/display-address/display-address.component';
import './common/components/input-address/input-address.component';
import './common/components/installation-prompt';
import './common/components/select-country/country-api.service';
import './common/components/select-country/select-country.component';
import './common/controllers/home-content-controller';
import './common/controllers/main-controller';
import './common/controllers/token-controller';
import './common/directives/appearance-directive';
import './common/directives/current_section-directive';
import './common/directives/directives';
import './common/directives/home_icons-directive';
import './common/directives/html_links-directive';
import './common/directives/infinite_scroll-directive';
import './common/directives/main_content_wrapper-directive';
import './common/directives/preview_carousel_slider-directive';
import './common/filters/filters';
import './common/lang/lang_en';
import './common/lang/lang_es';
import './common/lang/lang_pt';
import './common/services/analytics-service';
import './common/services/appearance-config-service';
import './common/services/appi-service';
import './common/services/config-service';
import './common/services/device-service';
import './common/services/modal-service';
import './common/services/location-service';
import './common/services/route-interceptor-service';
import './common/services/storage-service';
import './common/services/translator-service';
import './common/services/umetadata-service';
import './common/services/url-resolver-service';
import './common/services/utils-service';
import './common/utils/android-youtube-pause';
import './modules/about/controllers/about-controllers';
import './modules/about/directives/about-current_section-directive';
import './modules/about/directives/about-nav_bar-directive';
import './modules/about/directives/google-map-directive';
import './modules/about/lang/about-lang_en';
import './modules/about/lang/about-lang_es';
import './modules/about/lang/about-lang_pt';
import './modules/about/routes/about-routes';
import './modules/about/services/about-services';
import './modules/booking/controllers/booking-controllers';
import './modules/booking/directives/booking-calendar-directive';
import './modules/booking/lang/booking-lang_en';
import './modules/booking/lang/booking-lang_es';
import './modules/booking/lang/booking-lang_pt';
import './modules/booking/routes/booking-routes';
import './modules/booking/services/booking-services';
import './modules/cart/controllers/cart-controllers';
import './modules/cart/directives/cart-bread_crumb-directive';
import './modules/cart/directives/cart-current_section-directive';
import './modules/cart/directives/cart-remove_order-directive';
import './modules/cart/directives/cart-shipping_billing_address-directive';
import './modules/cart/factories/cart-order-factory';
import './modules/cart/lang/cart-lang_en';
import './modules/cart/lang/cart-lang_es';
import './modules/cart/lang/cart-lang_pt';
import './modules/cart/routes/cart-routes';
import './modules/cart/services/cart-services';
import './modules/cart/services/shippingCharges-services';
import './modules/cart/services/pickAtStoreOptions-services';
import './modules/cart/services/wiretransfer-services';
import './modules/customer-account/component/account-fields.component';
import './modules/customer-account/component/customer-fields.component';
import './modules/customer-account/component/password-change.component';
import './modules/customer-account/component/register-fields.component';
import './modules/customer-account/directives/customer-field-type-valiation.directive';
import './modules/customer-account/directives/password-confirmation-for.directive';
import './modules/customer-account/services/customer-account-api.service';
import './modules/customer-account/services/customer-account.service';
import './modules/customer-account/services/customer-field-type.service';
import './modules/eshop/controllers/eshop-controllers';
import './modules/eshop/directives/catalog-filters-directive';
import './modules/eshop/lang/eshop-lang_en';
import './modules/eshop/lang/eshop-lang_es';
import './modules/eshop/lang/eshop-lang_pt';
import './modules/eshop/routes/eshop-routes';
import './modules/eshop/services/eshop-services';
import './modules/free/controllers/free-controller';
import './modules/free/lang/free-lang_en';
import './modules/free/lang/free-lang_es';
import './modules/free/lang/free-lang_pt';
import './modules/free/routes/free-routes';
import './modules/free/services/free-content-adapter.service';
import './modules/free/services/free-module-api.service';
import './modules/loyalty/controllers/loyalty-card-controllers';
import './modules/loyalty/controllers/loyalty-list-controllers';
import './modules/loyalty/lang/loyalty-lang_en';
import './modules/loyalty/lang/loyalty-lang_es';
import './modules/loyalty/lang/loyalty-lang_pt';
import './modules/loyalty/routes/loyalty-routes';
import './modules/loyalty/services/loyalty-services';
import './modules/notifications/controllers/notifications-controller';
import './modules/notifications/directives/notification-directive';
import './modules/notifications/lang/notifications-lang_en';
import './modules/notifications/lang/notifications-lang_es';
import './modules/notifications/lang/notifications-lang_pt';
import './modules/notifications/routes/notifications-routes';
import './modules/notifications/services/notifications-service';
import './modules/outlets/controllers/outlets-controllers';
import './modules/outlets/lang/outlets-lang_en';
import './modules/outlets/lang/outlets-lang_es';
import './modules/outlets/lang/outlets-lang_pt';
import './modules/outlets/routes/outlets-routes';
import './modules/outlets/services/outlets-services';
import './modules/points/controllers/points-controller';
import './modules/points/controllers/points-assign-controller';
import './modules/points/controllers/points-redeem-controller';
import './modules/points/lang/points-lang_en';
import './modules/points/lang/points-lang_es';
import './modules/points/lang/points-lang_pt';
import './modules/points/routes/points-routes';
import './modules/points/services/points-services';
import './modules/restaurant/controllers/category-controller';
import './modules/restaurant/controllers/food-controller';
import './modules/restaurant/controllers/restaurant-controller';
import './modules/restaurant/directives/cart-count-directive';
import './modules/restaurant/lang/restaurant-lang_en';
import './modules/restaurant/lang/restaurant-lang_es';
import './modules/restaurant/lang/restaurant-lang_pt';
import './modules/restaurant/routes/restaurant-routes';
import './modules/restaurant/services/restaurant-services';
import './modules/tripadvisor/controllers/tripadvisor-controller';
import './modules/tripadvisor/lang/tripadvisor-lang_en';
import './modules/tripadvisor/lang/tripadvisor-lang_es';
import './modules/tripadvisor/lang/tripadvisor-lang_pt';
import './modules/tripadvisor/routes/tripadvisor-routes';
import './modules/tripadvisor/services/tripadvisor-services';
import './plugins/login/account';
import './plugins/login/controllers/change-password-controller';
import './plugins/login/directives/modal-change-password-tpl_directive';
import './plugins/login/directives/modal-email-restore-tpl_directive';
import './plugins/login/directives/modal-user-activated-success-tpl_directive';
import './plugins/login/security';
import './plugins/login/services/account-manager.service';
import './plugins/login/services/restore-service';
import './plugins/orders/controllers/orders-controller';
import './plugins/orders/routes/orders-routes';
import './plugins/orders/services/orders-service';
import './plugins/products/controllers/products-controllers';
import './plugins/products/directives/product-amount-directive';
import './plugins/products/directives/product_attributes_selector-directive';
import './plugins/products/directives/products-prices-directive';
import './plugins/products/directives/products-templates-directive';
import './plugins/products/factories/products-dao-factory';
import './plugins/products/factories/products-product-factory';
import './plugins/products/lang/products-lang_en';
import './plugins/products/lang/products-lang_es';
import './plugins/products/lang/products-lang_pt';
import './plugins/products/services/products-categories-service';



// WEBPACK FOOTER //
// ./src/app/index.js